export default __webpack_public_path__ + "static/media/P.130b41b1.svg";